import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card } from 'antd';
import ProposalForm from '../proposal_form/ProposalForm';

const queryString = require('qs');
const { Content } = Layout;

class NewWorkOrderProposalPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
	}

	render() {
		const { location, match, history } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const workOrderId = match.params.id;
		const formData = {
			workOrderId: workOrderId,
		};
		return (
			<Content>
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<Row style={{ margin: '0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<Card>
							<div>
								<ProposalForm formData={formData} onSuccess={history.goBack} />
							</div>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewWorkOrderProposalPage));
